export default __webpack_public_path__ + "static/img2-022e0af7c3b87bde5645de3ef25e7744.png";